import { createContext } from "react";
const UserContext = createContext();
const ScreenContext = createContext();

export { UserContext, ScreenContext };
